// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1igSK","colMin":"styles_colMin__1OFpD"};